import { createContext, useContext } from 'react';

// For more details on aria props that the input area needs to implement, see
// https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-autocomplete
export interface EditorContextOptions {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly 'aria-autocomplete': 'list' | undefined;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly 'aria-controls': string | undefined;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  readonly 'aria-activedescendant': string | undefined;
}

const defaultEditorContextOptions: EditorContextOptions = {
  'aria-autocomplete': undefined,
  'aria-controls': undefined,
  'aria-activedescendant': undefined,
};

export const EditorContext = createContext<EditorContextOptions>(defaultEditorContextOptions);

export type UseEditorContext = () => EditorContextOptions;
export const useEditorContext: UseEditorContext = () => useContext(EditorContext);
